<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <div class="locations-title">BOOK A GROUP</div>

          From summer camps to high school class trips, and from church outings
          to scout adventures, we can accommodate—and guide—large-group events
          at any of our five locations. Monday to Friday (no weekends).
          <div class="font-weight-bold mt-4">
            <strong>Guided group rates:</strong>
          </div>
          <ul>
            <li>
              Paddlers 8th grade or below: $12 per person in a canoe; $25 per
              person in a kayak.
            </li>
            <li>
              Paddlers 9th grade or above: $15 per person in a canoe; $30 per
              person in a kayak.
            </li>
            <li>
              We require one adult chaperone per ten paddlers under 18 years of
              age.
            </li>
            <li>Minimum rate of $300.</li>
          </ul>
          <div class="font-weight-bold mt-4">
            <strong>Unguided groups:</strong>
          </div>
          <ul>
            <!-- <li>
              20 percent discount on standard hourly rates for unguided group
              events of ten (10) boats or more.
            </li> -->
            <li>
              Must have one adult chaperone per ten (10) paddlers under 18 years of age
            </li>
            <li>
              Parental waiver required for all paddlers under 18 years of age
            </li>  
          </ul>
          <div class="text-center">
            <br />
            <a class="btn-primary btn" href="#/GroupContact"
              ><strong>Contact</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Groups",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
 padding-left: 1rem;
}
.page {
  flex-direction: column;
  background-image: url("../assets/groups1.jpg");
}
a.btn:hover {
  color: rgb(192, 80, 77);
}
/* ul {
  list-style-type: none;
} */
.note-text {
  color: red;
  margin-top: 20px;
}
a.btn-primary {
  margin-top: -35px;
  margin-bottom: 2px;
  text-align: center;
  display: inline-block;
}
</style>
